import axios from 'api';

// /api/super/reference/actions/ — global action templates (super-admin).
// Response envelope: { data, error, message }. Paginated lists live under data.results.
// Backend filterset: { scope: ["exact"] }. Search: name, key, description.

export const getActionData = (filtersData, signal) => {
  const { page_size, page, search, scope } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (scope) params.set('scope', scope);
  return axios.get(`/api/super/reference/actions/?${params.toString()}`, { signal });
};

export const createAction = (params) => axios.post(`/api/super/reference/actions/`, params);

export const updateAction = (params) => axios.patch(`/api/super/reference/actions/${params.id}/`, params);

export const deleteAction = (id) => axios.delete(`/api/super/reference/actions/${id}/`);

// /api/super/reference/action-points/
// Backend filterset: { action: ["exact"], value_type: ["exact"] }. Search: name, key.
// NOTE: the legacy `actionId` argument maps to the backend `action` filter
// (the spec previously called it `action__id`, which django-filter silently ignores).

export const getActionPointsData = (filtersData, signal) => {
  const { page_size, page, search, actionId, action, value_type } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  const actionFilter = action ?? actionId;
  if (actionFilter != null && actionFilter !== '') params.set('action', actionFilter);
  if (value_type) params.set('value_type', value_type);
  return axios.get(`/api/super/reference/action-points/?${params.toString()}`, { signal });
};

export const createActionPoints = (params) => axios.post(`/api/super/reference/action-points/`, params);

export const updateActionPoints = (params) => axios.patch(`/api/super/reference/action-points/${params.id}/`, params);

export const deleteActionPoints = (id) => axios.delete(`/api/super/reference/action-points/${id}/`);

// "Get all" — super-admin has no get_all flag; bump page_size instead.
export const getAllPublicActions = () => axios.get(`/api/super/reference/actions/?page_size=1000`);

// ─── Legacy stubs (tenant-scoped action CRUD has no super-admin equivalent) ───
import { removedStub } from 'api/_legacy';
export const getCustomerActionData = removedStub('getCustomerActionData');
export const createCustomerAction = removedStub('createCustomerAction');
export const updateCustomerAction = removedStub('updateCustomerAction');
export const deleteCustomerAction = removedStub('deleteCustomerAction');
